import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getMessaging } from 'firebase/messaging'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyDtxbtZceEgSenWa4gr0rkeCfL3FYo3U6c',
  authDomain: 'yuno-notifications.firebaseapp.com',
  projectId: 'yuno-notifications',
  storageBucket: 'yuno-notifications.appspot.com',
  messagingSenderId: '71729773405',
  appId: '1:71729773405:web:d5b6dbeea35440151506b4',
  measurementId: 'G-NFDYVYP596',
  databaseURL: 'https://yuno-notifications-default-rtdb.firebaseio.com/',
}

const app = initializeApp(firebaseConfig)
getAnalytics(app)
export const messaging = getMessaging(app)
export const db = getDatabase(app)
